export default () => ({
  obstetricData: undefined
})
